<i [class]="concatenatedClasses"></i>
